module.exports = __webpack_public_path__ + "img/orange_phone.9aa067ee.svg";